import React from 'react';
// import { Card } from 'react-bootstrap';

const ValutazioneRilevanzaRischiEtMitigazioni = () => {
  return (<></>);
};

export default ValutazioneRilevanzaRischiEtMitigazioni;
